import { render } from "./KpiCompliancePanel.vue?vue&type=template&id=776ac498&scoped=true&ts=true"
import script from "./KpiCompliancePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./KpiCompliancePanel.vue?vue&type=script&setup=true&lang=ts"

import "./KpiCompliancePanel.vue?vue&type=style&index=0&id=776ac498&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776ac498"],['__file',"resources/js/views/home/components/kpi-compliance/KpiCompliancePanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "776ac498"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('776ac498', __exports__)) {
    console.log('reload')
    api.reload('776ac498', __exports__)
  }
  
  module.hot.accept("./KpiCompliancePanel.vue?vue&type=template&id=776ac498&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('776ac498', render)
  })

}


export default __exports__